import React from "react";
import "./InfoPopup.css";

interface PopupProps {
  message: string;
  onClose: () => void;
}

export default function InfoPopup({ message, onClose }: PopupProps) {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <p>{message}</p>
        <button onClick={onClose}>Закрыть</button>
      </div>
    </div>
  );
}
